export const LAYOUT = {
  DEFAULT: 'Default',
  NAKED: 'Naked',
} as const

export type Layout = (typeof LAYOUT)[keyof typeof LAYOUT]
